import {
    ResponsiveGrid,
    ResponsiveGridItem,
} from '../../../../../controls/ResponsiveGrid';

export interface ReportingDashboardSectionProps {
    className?: string;
    children?: React.ReactElement;
}

export interface SectionProps {
    className?: string;
}

export const SectionItem = ResponsiveGridItem;

const ReportingDashboardSection: React.FC<ReportingDashboardSectionProps> = ({
    className,
    children,
}) => {
    return <ResponsiveGrid className={className}>{children}</ResponsiveGrid>;
};

export default ReportingDashboardSection;
